import { Injectable } from '@angular/core';
import {RestHttpService} from "@catcore/services/rest-http.service";
import {Restangular} from "ngx-restangular";
import {Store} from "@ngrx/store";

@Injectable()
export class GgwProfilePolicyService extends RestHttpService<any> {

  constructor(private service: Restangular,
              private store: Store<any>) {
    super('ggw-profile-policies', service);
  }

  setActive() {
    //this.store.dispatch({type: componentActions.PROJECT_DETAILS_GGW_ACTIVATE});
  }

  setInActive() {
    //this.store.dispatch({type: componentActions.PROJECT_DETAILS_GGW_DEACTIVATE});
  }
}


// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/ggw-profiles/services/ggw-profile-policy.service.ts